<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { isHiring } from '$lib/stores/selection';
</script>

<!--
  Beside ApprenticeshipFilter and for its reason, not in ContactFilters.

  That grid asks whether we hold a way of reaching a company. This asks
  something about the company itself, and "Kanäle: Website, E-Mail, Stellen
  ausgeschrieben" is a sentence that means nothing. These two are now a pair:
  the only filters in the panel that describe the company rather than our
  reach, and they read as a pair sitting together.

  # No guided step, deliberately

  The apprenticeship filter had one and lost it on 2026-09-30, because a door
  of four or five questions should not spend one of them on a narrow filter.
  This one is narrower still — it can only ever be true for a company that
  advertises on jobs.ch — so it starts where that one ended up, in the sidebar
  for the customer who goes looking for it.
-->
<div class="p-3">
  <!--
    The caveat is on the control rather than in a paragraph, as next door.

    It carries more than the apprenticeship one has to. Ticking this drops every
    company that hires without advertising on jobs.ch, which is most of them;
    agencies are excluded on purpose, since their vacancies belong to clients
    they do not name; and a quarter of the advertisements carry no company
    identifier at all. A customer reading the count afterwards cannot tell a
    small result from a partial view of a large one, so the sentence has to
    exist and be reachable — and a `title` is the honest fit for a 320px rail.
  -->
  <label class="group flex cursor-pointer items-start" title={$_('filters.hiring.explain')}>
    <input
      type="checkbox"
      bind:checked={$isHiring}
      class="mr-2 mt-0.5 h-3 w-3 shrink-0 rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
    />
    <!-- A megaphone: the company is announcing something, which is what an
         advertisement is. Distinct at 16px from the apprenticeship cap above. -->
    <svg class="filter-mark mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
      />
    </svg>

    <span class="min-w-0">
      <span
        class="block text-xs font-semibold text-gray-900 transition-colors group-hover:text-gray-700"
      >
        {$_('filters.hiring.label')}
      </span>
      <span class="mt-0.5 block text-2xs text-gray-500">
        {$_('filters.hiring.hint')}
      </span>
    </span>
  </label>
</div>
